import { apiHostname } from '../config'
import authService from '../services/auth'
import { localStorage, request } from './index'

const UploadType = {
  FILE: 'file',
  IMAGE: 'image'
}

export default {
  getProps (apiUrl, options) {
    const defaultOptions = {
      name: 'image',
      accept: '.jpg, .jpeg, .png',
      multiple: false
    }
    options = Object.assign(defaultOptions, options || {})
    const { accept, data, name, multiple, beforeUpload, onError, onProgress, onStart, onSuccess } = options
    return {
      action: `${apiHostname}${apiUrl}`,
      headers: { Authorization: `Bearer ${authService.getCurrentToken()}` },
      data,
      name,
      accept,
      multiple,
      beforeUpload (file) {
        if (typeof beforeUpload === 'function') {
          beforeUpload(file)
        }
      },
      onError (err, response, file) {
        if (typeof onError === 'function') {
          onError(err, response, file)
        } else {
          console.error(err, response, file)
        }
      },
      onProgress (step, file) {
        if (typeof onProgress === 'function') {
          onProgress(step, file)
        }
      },
      onStart (file) {
        if (typeof onStart === 'function') {
          onStart(file)
        }
      },
      onSuccess (result, file, req) {
        if (typeof onSuccess === 'function') {
          onSuccess(result, file, req)
        }
      }
    }
  },
  UploadType: {
    FILE: UploadType.FILE,
    IMAGE: UploadType.IMAGE
  },
  async upload (id, info, token, type) {
    type = type || UploadType.IMAGE
    const { file } = info
    const { error, originFileOb } = file
    const { method, url } = error
    const formData = new window.FormData()
    formData.append('id', id)
    formData.append(type, originFileOb)
    localStorage.setItem('token', token)
    return request(url, {
      method,
      body: formData
    })
  }
}
